import * as React from 'react';

const SuccessIcon = ({fillColor = '#2961fa'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={52.028} height={52.028}>
    <g data-name="Group 233252" transform="translate(-1827 -422)">
      <rect
        data-name="Rectangle 14948"
        width={25.028}
        height={2.715}
        rx={1.357}
        transform="rotate(135 842.098 606.488)"
        fill={fillColor}
      />
      <rect
        data-name="Rectangle 14949"
        width={13.388}
        height={2.715}
        rx={1.357}
        transform="rotate(-135 1019.076 -154.07)"
        fill={fillColor}
      />
      <g
        data-name="Ellipse 499"
        transform="translate(1827 422)"
        fill="none"
        stroke={fillColor}
        strokeWidth={2}>
        <circle cx={26.014} cy={26.014} r={26.014} stroke="none" />
        <circle cx={26.014} cy={26.014} r={25.014} />
      </g>
    </g>
  </svg>
);

export default SuccessIcon;
